import { a as e, c as t, d as n, h as r, i, l as a, n as o, o as s, r as c, s as l, t as u } from "./ab-test.utils-YxSoNfxm.js";
import { t as d } from "./useAbTestPolling-p2KOWVaL.js";
import { BfLimitedTextInput as f, CMSNotification as p, ROUTES as m, useNotificationStore as ee } from "@editor/ui-utils";
import { QBtn as h, QCard as te, QCardActions as ne, QCardSection as g, QDialog as re, QForm as _, QSpace as ie, QTooltip as ae, copyToClipboard as oe } from "quasar";
import { computed as v, createBlock as y, createCommentVNode as b, createElementBlock as x, createElementVNode as S, createTextVNode as C, createVNode as w, defineComponent as T, mergeModels as E, normalizeClass as D, openBlock as O, ref as k, toDisplayString as A, unref as j, useModel as se, watch as M, withCtx as N } from "vue";
import { useI18n as ce } from "vue-i18n";
//#endregion
//#region src/lang/index.ts
var P = {
	en: { abTesting: {
		listTitle: "A/B headline tests",
		historyTitle: "A/B headline test history",
		editArticle: "Edit article",
		testNumber: "Test #{n}",
		state: "Status",
		stateRunning: "Active",
		stateCompleted: "Completed: Winner found",
		stateCompletedNoWinner: "Completed: No winner found",
		stateCanceled: "Stopped",
		stateNotStarted: "Pending",
		variants: "Variants",
		variant: "Variant",
		title: "Title",
		kickerAndTitle: "Kicker and title",
		winner: "Winner",
		noWinner: "No winner",
		startDate: "Start date",
		endDate: "End date",
		lastTested: "Last test",
		articleTitle: "Article",
		kicker: "Kicker",
		articleTitleLabel: "Current main headline on article level",
		teaserTitleLabel: "Current main headline for teasers",
		primaryChannel: "Primary channel",
		brand: "Brand",
		numberOfTests: "# of Tests",
		status: "Status",
		contentUuid: "Article UUID",
		ctr: "CTR",
		impressions: "Impressions",
		clicks: "Clicks",
		noTestsFound: "No A/B tests found",
		noTestsForArticle: "No A/B tests found for this article",
		filterByState: "Status",
		filterByBrand: "Brand",
		searchPlaceholder: "Search for kicker or main headline",
		allStates: "All",
		stopTest: "Stop test",
		started: "Started",
		stopped: "Stopped",
		createdBy: "Created by: {name}",
		statusPending: "Pending",
		statusWinner: "Winner",
		statusLoser: "Loser",
		dialogTitle: "A/B headline test",
		existingTitleLabel: "Existing main headline",
		variationB: "Enter headline variation 1",
		variationC: "Enter headline variation 2",
		currentKickerLabel: "Current kicker",
		alternativeLeadTextLabel: "Alternative lead text",
		startTestButton: "Start test",
		cancelButton: "Cancel",
		fieldBRequired: "Headline variation 1 is required",
		copyKicker: "Copy kicker",
		kickerCopiedToClipboard: "Kicker copied to clipboard",
		kickerBRequired: "Kicker variation 1 is required",
		kickerCRequired: "Kicker variation 2 is required",
		variationCRequired: "Headline variation 2 is required",
		testCreatedSuccess: "New test created",
		testCreatedButStartFailed: "The test was created but could not be started - open the test to retry.",
		testCreateError: "Failed to create test",
		activeTestExists: "A test is already running or pending for this article.",
		testCompletedWithWinner: "Your A/B headline test has finished — a winner was found!",
		testCompletedNoWinner: "Your A/B headline test has finished — no clear winner was found.",
		viewResults: "View results",
		testId: "Test ID",
		copiedToClipboard: "Test ID copied to clipboard"
	} },
	de: { abTesting: {
		listTitle: "A/B-Headline-Tests",
		historyTitle: "A/B-Headline-Test-Verlauf",
		editArticle: "Artikel bearbeiten",
		testNumber: "Test #{n}",
		state: "Status",
		stateRunning: "Aktiv",
		stateCompleted: "Abgeschlossen: Gewinner gefunden",
		stateCompletedNoWinner: "Abgeschlossen: Kein Gewinner gefunden",
		stateCanceled: "Gestoppt",
		stateNotStarted: "Ausstehend",
		variants: "Varianten",
		variant: "Variante",
		title: "Titel",
		kickerAndTitle: "Vorzeile und Titel",
		winner: "Gewinner",
		noWinner: "Kein Gewinner",
		startDate: "Startdatum",
		endDate: "Enddatum",
		lastTested: "Letzter Test",
		articleTitle: "Artikel",
		kicker: "Vorzeile",
		articleTitleLabel: "Aktuelle Hauptzeile auf Artikel-Ebene",
		teaserTitleLabel: "Aktuelle Hauptzeile für Teaser",
		primaryChannel: "Primärer Channel",
		brand: "Marke",
		numberOfTests: "# Tests",
		status: "Status",
		contentUuid: "Artikel-UUID",
		ctr: "CTR",
		impressions: "Impressions",
		clicks: "Klicks",
		noTestsFound: "Keine A/B-Tests gefunden",
		noTestsForArticle: "Keine A/B-Tests für diesen Artikel gefunden",
		filterByState: "Status",
		filterByBrand: "Marke",
		searchPlaceholder: "Suchen nach Vor- oder Hauptzeile",
		allStates: "Alle",
		stopTest: "Test stoppen",
		started: "Gestartet",
		stopped: "Gestoppt",
		createdBy: "Erstellt von: {name}",
		statusPending: "Ausstehend",
		statusWinner: "Gewinner",
		statusLoser: "Verlierer",
		dialogTitle: "A/B-Headline-Test",
		existingTitleLabel: "Bestehende Hauptzeile",
		variationB: "Hauptzeilen-Variante 1 eingeben",
		variationC: "Hauptzeilen-Variante 2 eingeben",
		currentKickerLabel: "Aktuelle Vorzeile",
		alternativeLeadTextLabel: "Alternativer Vorspann",
		startTestButton: "Test starten",
		cancelButton: "Abbrechen",
		fieldBRequired: "Hauptzeilen-Variante 1 ist erforderlich.",
		copyKicker: "Vorzeile kopieren",
		kickerCopiedToClipboard: "Vorzeile in Zwischenablage kopiert",
		kickerBRequired: "Vorzeilen-Variante 1 ist erforderlich.",
		kickerCRequired: "Vorzeilen-Variante 2 ist erforderlich.",
		variationCRequired: "Hauptzeilen-Variante 2 ist erforderlich.",
		testCreatedSuccess: "Neuer Test erstellt",
		testCreatedButStartFailed: "Der Test wurde erstellt, konnte aber nicht gestartet werden. Den Test öffnen, um es erneut zu versuchen.",
		testCreateError: "Test konnte nicht erstellt werden",
		activeTestExists: "Für diesen Artikel läuft bereits ein Test oder steht noch aus.",
		testCompletedWithWinner: "Dein A/B-Headline-Test ist abgeschlossen — ein Gewinner wurde gefunden!",
		testCompletedNoWinner: "Dein A/B-Headline-Test ist abgeschlossen — kein eindeutiger Gewinner gefunden.",
		viewResults: "Ergebnisse ansehen",
		testId: "Test-ID",
		copiedToClipboard: "Test-ID in Zwischenablage kopiert"
	} }
}, F = [{
	path: `/${m.abHeadlineTest.path}`,
	meta: { i18RouteTitleKey: m.abHeadlineTest.path },
	children: [{
		path: "",
		name: "ab_test_list",
		component: () => import("./ab-test-list.view-Bs74rtf2.js"),
		meta: { requiredRight: "articles:navigate" }
	}, {
		path: "history",
		name: "ab_test_history",
		component: () => import("./ab-test-history.view-CNNoh65p.js"),
		props: (e) => ({ contentUuid: e.query.contentUuid }),
		meta: { requiredRight: "articles:navigate" }
	}]
}], I = { class: "text-h6" }, L = { class: "row items-center q-mb-md" }, R = { class: "col" }, z = { class: "row items-center q-mb-md" }, B = { class: "col" }, V = { class: "row items-center q-mb-md" }, H = { class: "col" }, U = {
	key: 0,
	class: "row items-center q-mb-sm",
	"data-qa-ab-headline-test-alt-kicker": ""
}, W = { class: "text-weight-bold q-mr-xs" }, le = {
	key: 1,
	class: "q-mb-sm",
	"data-qa-ab-headline-test-alt-lead": ""
}, ue = { class: "text-weight-bold" }, G = /* @__PURE__ */ s(/* @__PURE__ */ T({
	__name: "create-test.dialog",
	props: /* @__PURE__ */ E({
		contentUuid: {},
		articleState: {},
		existingTitle: {},
		alternativeKicker: {},
		alternativeLeadText: {},
		showHistoryLink: { type: Boolean }
	}, {
		modelValue: { type: Boolean },
		modelModifiers: {}
	}),
	emits: /* @__PURE__ */ E(["test-created"], ["update:modelValue"]),
	setup(e, { emit: t }) {
		let n = e, i = se(e, "modelValue"), a = t, { t: o } = ce(), s = ee(), c = k(null), u = k(n.existingTitle), d = k(""), m = k(""), T = k(""), E = k(""), P = k(""), F = k(!1), G = v(() => !!T.value.trim()), K = v(() => !!m.value.trim()), q = v(() => !!P.value.trim()), de = () => {
			oe(n.alternativeKicker ?? "").then(() => {
				s.showNotification(new p(o("abTesting.kickerCopiedToClipboard"), "positive"));
			}).catch(() => {});
		}, J = (e) => !!e.trim() || o("abTesting.fieldBRequired"), fe = (e) => !G.value || !!e.trim() || o("abTesting.kickerBRequired"), Y = (e) => !G.value || !K.value || !!e.trim() || o("abTesting.kickerCRequired"), pe = (e) => !q.value || !!e.trim() || o("abTesting.variationCRequired");
		M(() => n.existingTitle, (e) => {
			u.value = e;
		});
		let X = () => {
			c.value?.resetValidation();
		};
		M(G, (e) => {
			e || (E.value = "", P.value = ""), X();
		}), M(() => `${K.value}|${q.value}`, X);
		let Z = () => {
			u.value = n.existingTitle, d.value = "", m.value = "", T.value = "", E.value = "", P.value = "", F.value = !1, c.value?.resetValidation(), i.value = !1;
		}, Q = (e, t, n) => ({
			type: "HEADLINE",
			id: crypto.randomUUID(),
			label: e,
			title: t.trim(),
			...n.trim() ? { kicker: n.trim() } : {},
			isWinner: !1
		}), $ = async () => {
			let e = [Q("A", u.value, T.value), Q("B", d.value, E.value)];
			(K.value || q.value) && e.push(Q("C", m.value, P.value)), F.value = !0;
			try {
				let t = await l({
					_id: crypto.randomUUID(),
					contentUuid: n.contentUuid,
					state: "notStarted",
					variants: e
				}), i = t, c = !1;
				if (n.articleState === "publish") try {
					await r(t._id), i = {
						...t,
						state: "running"
					};
				} catch {
					c = !0;
				}
				s.showNotification(new p(o(c ? "abTesting.testCreatedButStartFailed" : "abTesting.testCreatedSuccess"), c ? "warning" : "positive")), a("test-created", i), Z();
			} catch {
				s.showNotification(new p(o("abTesting.testCreateError"), "negative"));
			} finally {
				F.value = !1;
			}
		}, me = async () => {
			await c.value?.validate() && await $();
		};
		return (t, r) => (O(), y(j(re), {
			"data-qa-ab-headline-test-dialog": "",
			"model-value": i.value,
			persistent: "",
			onHide: Z
		}, {
			default: N(() => [w(j(te), { class: "create-test-dialog" }, {
				default: N(() => [
					w(j(g), { class: "row items-center q-pb-none" }, {
						default: N(() => [
							S("div", I, A(j(o)("abTesting.dialogTitle")), 1),
							w(j(ie)),
							w(j(h), {
								icon: "close",
								flat: "",
								round: "",
								dense: "",
								onClick: Z
							})
						]),
						_: 1
					}),
					w(j(g), null, {
						default: N(() => [w(j(_), {
							ref_key: "formRef",
							ref: c,
							greedy: "",
							onSubmit: $
						}, {
							default: N(() => [
								S("div", L, [r[6] ||= S("div", { class: "variant-label text-weight-bold q-mr-sm" }, "A", -1), S("div", R, [w(j(f), {
									modelValue: T.value,
									"onUpdate:modelValue": r[0] ||= (e) => T.value = e,
									"data-qa-ab-headline-test-kicker-a": "",
									label: j(o)("abTesting.kicker"),
									outlined: "",
									dense: "",
									"hide-bottom-space": "",
									class: "q-my-sm",
									"max-perfect-length": 30,
									"max-length": 40
								}, null, 8, ["modelValue", "label"]), w(j(f), {
									modelValue: u.value,
									"onUpdate:modelValue": r[1] ||= (e) => u.value = e,
									"data-qa-ab-headline-test-existing-title": "",
									label: j(o)("abTesting.existingTitleLabel"),
									outlined: "",
									dense: "",
									"hide-bottom-space": "",
									class: "q-my-sm required",
									rules: [J],
									"max-perfect-length": 70,
									"max-length": 80
								}, null, 8, [
									"modelValue",
									"label",
									"rules"
								])])]),
								S("div", z, [r[7] ||= S("div", { class: "variant-label text-weight-bold q-mr-sm" }, "B", -1), S("div", B, [w(j(f), {
									modelValue: E.value,
									"onUpdate:modelValue": r[2] ||= (e) => E.value = e,
									"data-qa-ab-headline-test-kicker-b": "",
									label: j(o)("abTesting.kicker"),
									outlined: "",
									dense: "",
									"hide-bottom-space": "",
									class: D(["q-my-sm", { required: G.value }]),
									disable: !G.value,
									rules: [fe],
									"max-perfect-length": 30,
									"max-length": 40
								}, null, 8, [
									"modelValue",
									"label",
									"class",
									"disable",
									"rules"
								]), w(j(f), {
									modelValue: d.value,
									"onUpdate:modelValue": r[3] ||= (e) => d.value = e,
									"data-qa-ab-headline-test-variation-1": "",
									label: j(o)("abTesting.variationB"),
									outlined: "",
									dense: "",
									"hide-bottom-space": "",
									class: "q-my-sm required",
									rules: [J],
									"max-perfect-length": 70,
									"max-length": 80
								}, null, 8, [
									"modelValue",
									"label",
									"rules"
								])])]),
								S("div", V, [r[8] ||= S("div", { class: "variant-label text-weight-bold q-mr-sm" }, "C", -1), S("div", H, [w(j(f), {
									modelValue: P.value,
									"onUpdate:modelValue": r[4] ||= (e) => P.value = e,
									"data-qa-ab-headline-test-kicker-c": "",
									label: j(o)("abTesting.kicker"),
									outlined: "",
									dense: "",
									"hide-bottom-space": "",
									class: D(["q-my-sm", { required: G.value && K.value }]),
									disable: !G.value,
									rules: [Y],
									"max-perfect-length": 30,
									"max-length": 40
								}, null, 8, [
									"modelValue",
									"label",
									"class",
									"disable",
									"rules"
								]), w(j(f), {
									modelValue: m.value,
									"onUpdate:modelValue": r[5] ||= (e) => m.value = e,
									"data-qa-ab-headline-test-variation-2": "",
									label: j(o)("abTesting.variationC"),
									outlined: "",
									dense: "",
									"hide-bottom-space": "",
									class: D(["q-my-sm", { required: q.value }]),
									rules: [pe],
									"max-perfect-length": 70,
									"max-length": 80
								}, null, 8, [
									"modelValue",
									"label",
									"class",
									"rules"
								])])]),
								e.alternativeKicker ? (O(), x("div", U, [
									S("span", W, A(j(o)("abTesting.currentKickerLabel")) + ":", 1),
									S("span", null, A(e.alternativeKicker), 1),
									w(j(h), {
										"data-qa-ab-headline-test-copy-alt-kicker": "",
										flat: "",
										dense: "",
										round: "",
										size: "xs",
										icon: "content_copy",
										class: "q-ml-xs",
										onClick: de
									}, {
										default: N(() => [w(j(ae), null, {
											default: N(() => [C(A(j(o)("abTesting.copyKicker")), 1)]),
											_: 1
										})]),
										_: 1
									})
								])) : b("", !0),
								e.alternativeLeadText ? (O(), x("div", le, [S("span", ue, A(j(o)("abTesting.alternativeLeadTextLabel")) + ":", 1), C(" " + A(e.alternativeLeadText), 1)])) : b("", !0),
								e.showHistoryLink ? (O(), y(j(h), {
									key: 2,
									"data-qa-ab-headline-test-view-history": "",
									flat: "",
									dense: "",
									"no-caps": "",
									color: "primary",
									label: j(o)("abTesting.historyTitle"),
									to: {
										name: "ab_test_history",
										query: { contentUuid: n.contentUuid }
									}
								}, null, 8, ["label", "to"])) : b("", !0)
							]),
							_: 1
						}, 512)]),
						_: 1
					}),
					w(j(ne), {
						align: "left",
						class: "q-pt-none q-px-md q-pb-md"
					}, {
						default: N(() => [w(j(h), {
							"data-qa-ab-headline-test-cancel-button": "",
							icon: "close",
							label: j(o)("abTesting.cancelButton"),
							outline: "",
							color: "dark",
							onClick: Z
						}, null, 8, ["label"]), w(j(h), {
							"data-qa-ab-headline-test-start-button": "",
							icon: "send",
							label: j(o)("abTesting.startTestButton"),
							color: "primary",
							loading: F.value,
							onClick: me
						}, null, 8, ["label", "loading"])]),
						_: 1
					})
				]),
				_: 1
			})]),
			_: 1
		}, 8, ["model-value"]));
	}
}), [["__scopeId", "data-v-676252d3"]]), K = {
	messages: P,
	routes: F,
	contentBlocks: []
};
//#endregion
export { G as CreateTestDialog, K as abTestingModule, l as createAbTest, t as deleteAbTest, a as endAbTest, n as fetchAbTestsForArticle, u as hasNoWinner, o as isAbTestActive, r as startAbTest, c as stateLabel, i as stateTextClass, e as testStateLabel, d as useAbTestPolling };

//# sourceMappingURL=index.es.js.map